import React from 'react';

// Custom loader with skull and crossed wrenches
export const SkullLoader = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  return (
    <div className={`animate-pulse ${className}`}>
      <svg 
        viewBox="0 0 100 100" 
        className={`${sizeClasses[size]} text-[#FF5F1F]`}
        fill="currentColor"
      >
        {/* Wrench 1 (left, angled) */}
        <g transform="rotate(-45 50 50)">
          <rect x="20" y="46" width="60" height="8" rx="2" className="opacity-80"/>
          <circle cx="20" cy="50" r="10" className="opacity-80"/>
          <circle cx="20" cy="50" r="5" fill="#0a0a0a"/>
          <path d="M75 42 L85 42 L85 46 L80 50 L85 54 L85 58 L75 58 Z" className="opacity-80"/>
        </g>
        
        {/* Wrench 2 (right, angled) */}
        <g transform="rotate(45 50 50)">
          <rect x="20" y="46" width="60" height="8" rx="2" className="opacity-80"/>
          <circle cx="20" cy="50" r="10" className="opacity-80"/>
          <circle cx="20" cy="50" r="5" fill="#0a0a0a"/>
          <path d="M75 42 L85 42 L85 46 L80 50 L85 54 L85 58 L75 58 Z" className="opacity-80"/>
        </g>
        
        {/* Skull */}
        <ellipse cx="50" cy="42" rx="22" ry="20" fill="currentColor"/>
        <ellipse cx="50" cy="55" rx="12" ry="10" fill="currentColor"/>
        
        {/* Eye sockets */}
        <ellipse cx="42" cy="40" rx="6" ry="7" fill="#0a0a0a"/>
        <ellipse cx="58" cy="40" rx="6" ry="7" fill="#0a0a0a"/>
        
        {/* Nose */}
        <path d="M50 48 L47 54 L53 54 Z" fill="#0a0a0a"/>
        
        {/* Teeth */}
        <rect x="42" y="58" width="4" height="6" fill="#0a0a0a" rx="1"/>
        <rect x="48" y="58" width="4" height="6" fill="#0a0a0a" rx="1"/>
        <rect x="54" y="58" width="4" height="6" fill="#0a0a0a" rx="1"/>
      </svg>
    </div>
  );
};

// Full page loader with skull
export const SkullPageLoader = ({ text = 'Caricamento...' }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
    <SkullLoader size="xl" className="animate-bounce" />
    <p className="text-[#FF5F1F] font-['Teko'] text-xl uppercase tracking-wider animate-pulse">
      {text}
    </p>
  </div>
);

// Inline loader
export const SkullInlineLoader = ({ text }) => (
  <div className="flex items-center gap-3">
    <SkullLoader size="sm" />
    {text && <span className="text-[#9CA3AF]">{text}</span>}
  </div>
);

export default SkullLoader;
